import React, { PureComponent, Fragment } from 'react';
import moment from 'moment';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TumorTestResult } from '../ProfileBlocks/TumorTestResult';

import './application-table.scss';

export class ApplicationTable extends PureComponent {
  static propTypes = {
    showTitle: PropTypes.bool,
    data: PropTypes.object,
    config: PropTypes.shape({
      columns: PropTypes.array,
    }).isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    showTitle: true,
  };

  render() {
    const { data, config, className, showTitle } = this.props;

    const { columns } = config;
    const tableKeys = Object.keys(data) || [];
    const tableKeysData =
      tableKeys[0] === 'undefined' ? tableKeys.reverse() : tableKeys;

    return (
      <table className={classnames('application-table', className)}>
        {showTitle && tableKeysData.length ? (
          <thead className="application-table__header">
            <tr>
              {columns.map((item) => (
                <th
                  className="application-table__item application-table__item_header"
                  style={{ width: item.width || 'auto' }}
                  key={item.name}
                >
                  {item.title}
                </th>
              ))}
            </tr>
          </thead>
        ) : null}

        <tbody className="application-table__body">
          {tableKeysData.map((subtitle) => (
            <Fragment key={uuid(subtitle)}>
              <tr>
                {subtitle !== 'undefined' && (
                  <td
                    className="application-table__item application-table__item_subtitle"
                    colSpan={columns.length}
                  >
                    Date of Measurement: {moment(subtitle).format('MM/DD/YYYY')}
                  </td>
                )}
              </tr>
              {data[subtitle].map((row, rowIndex) => {
                return (
                  <tr key={uuid(`${subtitle}${rowIndex}`)}>
                    {columns.map((configItem, configItemIndex) => (
                      <td
                        className={classnames(
                          'application-table__item application-table__item_data',
                          {
                            'semi-bold fs-14': configItemIndex === 0,
                          },
                        )}
                        style={{ width: configItem.width || 'auto' }}
                        key={uuid(`${subtitle}${rowIndex}`)}
                      >
                        {Array.isArray(row[configItem.name]) ? (
                          <TumorTestResult data={row[configItem.name]} />
                        ) : (
                          row[configItem.name] &&
                          String(row[configItem.name]).replace(/;/g, '\n')
                        )}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </Fragment>
          ))}
        </tbody>
      </table>
    );
  }
}
